module.exports = __webpack_public_path__ + "img/bg-cant-find_small.54e93818.webp";